import React from 'react';
export function Footer() {
  return <footer className="w-full bg-brown text-white py-12 px-4" data-id="element-52">
      <div className="max-w-7xl mx-auto" data-id="element-53">
        <div className="text-center mb-8" data-id="element-54">
          <p className="font-playfair text-2xl font-bold mb-2" data-id="element-55">
            Secretos de los Jabones
          </p>
          <p className="font-inter text-sm text-white/70" data-id="element-56">
            Aprende y Emprende en Casa
          </p>
        </div>

        <div className="border-t border-white/20 pt-8 text-center" data-id="element-57">
          <p className="font-inter text-sm text-white/70 mb-4" data-id="element-58">
            © Aprende y Emprende en Casa — Todos los derechos reservados.
          </p>
          <p className="font-inter text-sm text-white/70 mb-4" data-id="element-59">
            Tu compra está protegida por Hotmart, empresa líder en educación en
            línea desde 2011.
          </p>
          <div className="flex items-center justify-center gap-6 text-sm text-white/70" data-id="element-60">
            <a href="#contacto" className="hover:text-white transition-colors" data-id="element-61">
              Contacto
            </a>
            <span data-id="element-62">•</span>
            <a href="#terminos" className="hover:text-white transition-colors" data-id="element-63">
              Términos
            </a>
            <span data-id="element-64">•</span>
            <a href="#privacidad" className="hover:text-white transition-colors" data-id="element-65">
              Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}